exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promocion-table-wrapper {\n  background-color: white;\n  margin: 2rem 0;\n  padding: 1rem;\n  position: relative; }\n  .promocion-table-wrapper table {\n    margin: 0 !important;\n    margin-top: 2rem !important;\n    padding: 2rem !important; }\n    .promocion-table-wrapper table thead {\n      background-color: #d0eeff; }\n    .promocion-table-wrapper table tr:nth-child(even) {\n      background: #f0f0f0; }\n  .promocion-table-wrapper .loading-data {\n    -ms-flex-align: center;\n        align-items: center;\n    background-color: white;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    -ms-flex-pack: center;\n        justify-content: center;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 99999; }\n    .promocion-table-wrapper .loading-data img {\n      max-width: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/detail-promotion/detail-table.component.scss
// module id = ../../../../../src/app/components/promociones/quantum/detail-promotion/detail-table.component.scss
// module chunks = main